export default "__VITE_ASSET__CI3S1n98__"